/* 🤖 this file was generated by svg-to-ts */
export const matIconDownloadForOffline: {
  name: 'download-for-offline';
  data: string;
} = {
  name: 'download-for-offline',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm2.59-11.41L16 10l-4 4-4-4 1.41-1.41L11 10.17V6h2v4.17l1.59-1.58zM17 17H7v-2h10v2z"/></svg>`
};
